import HttpResponse from "../../../../../common/utils/http/http.response";

export enum OrderJoinErrorType {
  ORDER_ASSIGNED_TO_DRIVER = "ORDER_ASSIGNED_TO_DRIVER",
  CHANGE_RIDE_RELATED = "CHANGE_RIDE_RELATED",
}

export enum OrderJoinChangeTargetRideErrorType {
  NODE_ALREADY_CHECKED_OUT = "NODE_ALREADY_CHECKED_OUT",
  RESULT_INCONSISTENT_TIMING = "RESULT_INCONSISTENT_TIMING",
  RESULT_TIMING_NOT_POSSIBLE = "RESULT_TIMING_NOT_POSSIBLE",
  RESULT_CARGO_PROGRESSION_ERROR = "RESULT_CARGO_PROGRESSION_ERROR",
  RESULT_CARGO_PROGRESSION_MISSING_ENTER_SUBJECT = "RESULT_CARGO_PROGRESSION_MISSING_ENTER_SUBJECT",
  NO_VALID_CARGO_TAXI_CONTRACT = "NO_VALID_CARGO_TAXI_CONTRACT",
  NO_VALID_CARGO_RAILY_CONTRACT = "NO_VALID_CARGO_RAILY_CONTRACT",
  NO_RELEVANT_DISPATCH_FOUND = "NO_RELEVANT_DISPATCH_FOUND",
  PASSENGERS_DO_OVERLAP = "PASSENGERS_DO_OVERLAP",
}

export type OrderJoinChangeTargetRideError = {
  errorType: OrderJoinChangeTargetRideErrorType;
};

export type OrderJoinNotAcceptableOrderAssignedToDriverError = {
  errorType: OrderJoinErrorType.ORDER_ASSIGNED_TO_DRIVER;
};

export type OrderJoinNotAcceptableChangeRideRelatedError = {
  errorType: OrderJoinErrorType.CHANGE_RIDE_RELATED;
  changeTargetRideError: OrderJoinChangeTargetRideError;
};

export type OrderJoinNotAcceptableError =
  | OrderJoinNotAcceptableOrderAssignedToDriverError
  | OrderJoinNotAcceptableChangeRideRelatedError;

export type OrderJoinNotAcceptableResponse =
  HttpResponse<OrderJoinNotAcceptableError>;

export type OrderJoinPreviewResponsePassenger = {
  id: string;
  firstName: string;
  lastName: string;
};

export type OrderJoinPreviewResponseDriver = {
  id: string;
  firstName: string;
  lastName: string;
  mobilePrimaryPrefix: string;
  mobilePrimary: string;
};

export type OrderJoinPreviewResponseRideWaypointMetaSubject = {
  id: string;
};

export type OrderJoinPreviewResponseRideWaypointMetaSubjectList = {
  subjects: OrderJoinPreviewResponseRideWaypointMetaSubject[];
};

export type OrderJoinPreviewResponseRideWaypointMeta = {
  id: string;
  cargoEnter: OrderJoinPreviewResponseRideWaypointMetaSubjectList;
  cargoExit: OrderJoinPreviewResponseRideWaypointMetaSubjectList;
};

export type OrderJoinPreviewResponseRideWaypoint = {
  lat: number;
  lon: number;
  time: Date | null;
  haltingTime: number;
  displayName: string;
  meta: OrderJoinPreviewResponseRideWaypointMeta;
};

export type OrderJoinPreviewResponseRideWaypointGroup = {
  seq: OrderJoinPreviewResponseRideWaypoint[];
  sequenceOrder: "ANY";
};

export type OrderJoinPreviewResponseRideSeqItem =
  | OrderJoinPreviewResponseRideWaypoint
  | OrderJoinPreviewResponseRideWaypointGroup;

export type OrderJoinOrderDetailsResponseCargoOrderRide = {
  seq: OrderJoinPreviewResponseRideSeqItem[];
  sequenceOrder: "STRICT";
};

export type OrderJoinOrderDetailsResponseSolvedOrderRideSeqItemMetaSubject = {
  id: string;
};

export type OrderJoinOrderDetailsResponseSolvedOrderRideSeqItemMetaSubjectList =
  {
    subjects: OrderJoinOrderDetailsResponseSolvedOrderRideSeqItemMetaSubject[];
  };

export type OrderJoinOrderDetailsResponseSolvedOrderRideSeqItemMeta = {
  cargoEnter: OrderJoinOrderDetailsResponseSolvedOrderRideSeqItemMetaSubjectList;
  cargoExit: OrderJoinOrderDetailsResponseSolvedOrderRideSeqItemMetaSubjectList;
  estimatedTime: string;
};

export type OrderJoinOrderDetailsResponseSolvedOrderRideSeqItem = {
  lat: number;
  lon: number;
  time: string | null;
  haltingTime: number;
  displayName: string;
  meta: OrderJoinOrderDetailsResponseSolvedOrderRideSeqItemMeta;
};

export type OrderJoinOrderDetailsResponseSolvedOrderRide = {
  seq: OrderJoinOrderDetailsResponseSolvedOrderRideSeqItem[];
  sequenceOrder: "STRICT" | "ANY";
};

export type OrderJoinOrderDetailsResponseSolvedOrder = {
  ride: OrderJoinOrderDetailsResponseSolvedOrderRide;
};

export type OrderJoinOrderDetailsResponseTransportingOrderCreatePlanEntryDriver =
  {
    id: string;
    firstName: string;
    lastName: string;
    mobilePrimaryPrefix: string;
    mobilePrimary: string;
  };

export type OrderJoinOrderDetailsResponseTransportingOrderCreatePlanEntry = {
  driver: OrderJoinOrderDetailsResponseTransportingOrderCreatePlanEntryDriver;
};

export type OrderJoinOrderDetailsResponseTransportingOrder = {
  solvedOrder: OrderJoinOrderDetailsResponseSolvedOrder | null;
  createPlanEntryEntries: OrderJoinOrderDetailsResponseTransportingOrderCreatePlanEntry[];
};

export type OrderJoinOrderDetailsResponseCargoOrder = {
  id: string;
  humanId: number;
  ride: OrderJoinOrderDetailsResponseCargoOrderRide;
  transportingOrders: OrderJoinOrderDetailsResponseTransportingOrder[];
  cargoItemsSourceList: OrderJoinOrderDetailsResponseCargoItemsSourceElement[];
};

export type OrderJoinOrderDetailsResponse = {
  passengers: OrderJoinPreviewResponsePassenger[];
  drivers: OrderJoinPreviewResponseDriver[];
  cargoOrder: OrderJoinOrderDetailsResponseCargoOrder;
  nodeExclusion: OrderJoinOrderDetailsResponseNodeExclusion;
};

export type OrderJoinOrderDetailsResponseNodeExclusion = {
  excludeApproaching: boolean;
  excludeInside: boolean;
  excludeReturning: boolean;
};

export enum OrderJoinOrderDetailsResponseSourceType {
  INTERNAL = "INTERNAL",
  EXTERNAL = "EXTERNAL",
}

export type OrderJoinOrderDetailsResponseInternalCargoItemSource = {
  sourceType: OrderJoinOrderDetailsResponseSourceType.INTERNAL;
};

export type OrderJoinOrderDetailsResponseExternalCargoItemSource = {
  sourceType: OrderJoinOrderDetailsResponseSourceType.EXTERNAL;
  firstName: string;
  lastName: string;
};

export type OrderJoinOrderDetailsResponseCargoItemsSourceElementCargoItemSource =

    | OrderJoinOrderDetailsResponseInternalCargoItemSource
    | OrderJoinOrderDetailsResponseExternalCargoItemSource;

export type OrderJoinOrderDetailsResponseCargoItemsSourceElement = {
  cargoSubjectId: string;
  cargoItemSource: OrderJoinOrderDetailsResponseCargoItemsSourceElementCargoItemSource;
};

export type OrderJoinSuccessResponse =
  HttpResponse<OrderJoinOrderDetailsResponse | null>;

type OrderJoinResponse =
  | OrderJoinSuccessResponse
  | OrderJoinNotAcceptableResponse;

export default OrderJoinResponse;
